export function getNetworkInfo(): NetworkInfo | undefined {
  if (!window.navigator.connection) {
    return undefined;
  }

  const networkConnectionType =
    window.navigator.connection.type === "unknown" ? undefined : window.navigator.connection.type;

  return {
    networkReducedData: window.navigator.connection.saveData ?? false,
    networkConnectionType,
    networkRtt: window.navigator.connection.rtt,
    networkDownlink: window.navigator.connection.downlink,
    networkDownlinkMax: window.navigator.connection.downlinkMax,
  };
}

type NetworkInfo = {
  networkReducedData: boolean;
  networkConnectionType: NetworkInformationConnectionType | undefined;
  networkRtt?: number;
  networkDownlink?: number;
  networkDownlinkMax?: number;
};
